export enum SenderQuoteStatus {
    Draft = 'Draft',
    Open = 'Open',
    Closed = 'Closed',
    Accepted = 'Accepted',
}
